import { render, staticRenderFns } from "./TokenUrl.vue?vue&type=template&id=e4f216a4&scoped=true&"
import script from "./TokenUrl.vue?vue&type=script&lang=js&"
export * from "./TokenUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f216a4",
  null
  
)

export default component.exports